import { Link, useLocation } from 'react-router-dom'

import { Project } from 'api/types'
import { tx } from 'lib/i18n'

import { useRegion } from '../context/RegionContext'
import { SidebarNavItem } from './SidebarNavItem'

export const DailyReportsNav = ({ project }: { project: Project | null }) => {
  const location = useLocation()
  const { locale } = useRegion()

  if (!project) {
    return (
      <SidebarNavItem
        icon="file"
        label={tx(locale, 'التقارير اليومية', 'Daily reports')}
        disabled
        disabledHint={tx(locale, 'اختر مشروعاً أولاً', 'Choose a project first')}
      />
    )
  }

  const base = `/projects/${project.id}`
  const inProject = location.pathname === base || location.pathname.startsWith(`${base}/`)
  const onIndex = location.pathname === base
  const status = onIndex ? new URLSearchParams(location.search).get('status') : null

  const subLink = (label: string, statusParam: string | null) => {
    const to = statusParam ? `${base}?status=${statusParam}` : base
    const active = onIndex && status === statusParam
    return (
      <Link key={label} to={to} className={active ? 'shell__nav-subitem is-active' : 'shell__nav-subitem'}>
        {label}
      </Link>
    )
  }

  return (
    <div className="shell__nav-group-item">
      <SidebarNavItem icon="file" label={tx(locale, 'التقارير اليومية', 'Daily reports')} to={base} active={inProject} />
      <nav className="shell__nav-subitems" aria-label={tx(locale, 'التقارير اليومية', 'Daily reports')}>
        {subLink(tx(locale, 'كل التقارير', 'All reports'), null)}
        {subLink(tx(locale, 'المسودات', 'Drafts'), 'DRAFT')}
        {subLink(tx(locale, 'المفقودة', 'Missing'), 'MISSING')}
      </nav>
    </div>
  )
}
